import { intl } from "@fidget/common/i18n";
import { range } from "lodash";
import { Capacity } from "./capacityPicker";

export const orgCapacityOption = (): Capacity => ({
    name: intl.formatMessage("capacityPicker.turnOffIndividualLimit"),
    value: undefined,
});

export const zeroCapacityOption = (): Capacity => ({
    name: intl.formatMessage("capacityPicker.turnOffAutoAssignment"),
    value: 0,
});

export const mapLimitsToCapacities = (limits: number[]): Capacity[] =>
    limits.map((limit) => ({ name: limit.toString(), value: limit }));

export const CAPACITY_OPTIONS = mapLimitsToCapacities(range(1, 100));
